import $ from 'jquery';
import ajax from '../services/ajax';
import analytics from '../services/analytics_service';
// Template: redesign-slot-fastcompany/sites/all/static/public/templates/modules/collection_poll.hbs
// Styles: redesign-slot-fastcompany/sites/all/src/scss/modules/_collection_poll.scss

const pollView = (el) => {
    const $el = $(el);
    const $story = $el.find('.poll-post-wrapper');
    const storyUrl = $story.find('a').attr('href');
    const dataModel = $el.attr('data-model');
    let votedStorage;
    let previouslyVoted;
    function calculatePercentageOfDataSet(dataSet) {
        const sum = dataSet.reduce(function (prevValue, currValue) {
            return prevValue + currValue;
        });

        return dataSet.map(function (dataPoint) {
            return 100 * dataPoint / sum;
        });
    }

    function trackClick() {
        analytics.handleOutboundLinkClicks('Poll', 'click', storyUrl);
    }

    function setUpCollectionPoll() {

        let json = false;
        try {
            if (dataModel) {
                json = JSON.parse(dataModel);
            }
        } catch (err) { // eslint-disable-line no-empty
            // TODO: log error
            // console.error(err);
        }
        if (json !== false) {
            const { id } = json;
            const $pollAnswer = $el.find('.fake-input');
            votedStorage = `FC_POLL_${id}}`;
            previouslyVoted = window.localStorage.getItem(votedStorage);

            // We need to do this bc fastly caches our pages!
            if (previouslyVoted && id) {
                return ajax(`/poll-api/v3/modules/collection-poll`, {
                    method: 'GET',
                    dataType: 'json',
                    data: {
                        id
                    }
                }).then(displayData);
                    /*.catch(function displayDataFail(err) {
                        // TODO: do something..
                    });*/
            }

            $pollAnswer.one('click', handlePollVote.call($pollAnswer, id));
        }
    }

    // need to pull this stuff out into a model
    function displayData(data) {
        const poll = data.poll;
        const pollData = [poll.answer_one_count, poll.answer_two_count];
        const pollDataLookup = [{answer: poll.answer_one, data: poll.answer_one_count}, {answer: poll.answer_two, data: poll.answer_two_count}];
        const calculationsAray = calculatePercentageOfDataSet(pollData);
        const $inputs = $el.find('input');
        const $bars = $el.find('.bar');
        const $data = $el.find('.data');
        $el.addClass('voted');
        $el.find(`#${previouslyVoted}`).attr('checked', 'checked');
        $inputs.attr('disabled', 'true');
        // let $question = $el.find('.poll-question');
        // if (poll.voted_view_title) {
        //     $question.text(poll.voted_view_title);
        // }
        let i = 0;
        for (i; i < calculationsAray.length; i++) {
            $($data[i]).animate({width: calculationsAray[i].toString() + '%'}, 1000, 'linear');
            $($bars[i]).find('label').text(Math.round(calculationsAray[i]).toString() + '% said ' + pollDataLookup[i].answer);
        }

    }

    function handlePollVote(id) {
        // debugger;
        return (e) => {
            let $clicked = $(e.target);
            const $inputs = $el.find('input');
            if (!$inputs.attr('disabled')) {
                const selected = $clicked.prev()[0];
                const $selected = $clicked.prev();
                const answerId = selected.id;
                const answer = $selected.data('answer');
                window.localStorage.setItem(votedStorage, answerId);
                $selected.attr('checked', 'checked');
                return ajax(`/poll-api/v3/modules/collection-poll`, {
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        id,
                        answer
                    }
                }).then(displayData);
            }
        };
    }

    function init() {
        setUpCollectionPoll();
        $story.one('click', trackClick);
    }

    return {
        init: init
    };
};

const pollManager = () => {
    const init = () => {
        $('.js-collection-poll').each(createView);
    };

    const createView = (index, el) => {
        pollView(el).init();
    };

    return { init: init };
};

export  { pollManager } ;
